var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-auto"},[(_vm.error)?_c('v-alert',{staticClass:"mx-auto",attrs:{"color":"error","outlined":"","max-width":"800"}},[_vm._v(" "+_vm._s(_vm.error)+" ")]):_c('v-alert',{staticClass:"mx-auto",attrs:{"color":"primary","outlined":"","max-width":"800"}},[_vm._v(" Loading... ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }